import React from 'react'
import { Link } from 'react-router-dom'
import { config } from '@/lib/config'

export default function ContactAzEnTortenetemContent() {
  const iconCheck = <i className="bi bi-check-circle-fill text-green-600 mr-2"></i>;
  const iconStar = <i className="bi bi-star-fill text-amber-600 mr-2"></i>;

  return (
    <>
     <div className="space-y-6 p-6 text-lg">
      <div className="space-y-2">
        <p className="font-semibold">Mit ad neked ez a művészetterápiás foglalkozás?</p>
        <ul className="list-none space-y-2">
          <li className="flex items-center">
            <i className="bi bi-person mr-2 text-green-600"></i>
            Önismeretet – saját érzéseid és élményeid megfogalmazása
          </li>
          <li className="flex items-center">
            <i className="bi bi-brush mr-2 text-green-600"></i>
            Felszabadító alkotási folyamatot - különböző rajzi eszközök kipróbálásával
          </li>
          <li className="flex items-center">
            <i className="bi bi-people-fill mr-2 text-green-600"></i>
            Közösségi élményt – megoszthatod történetedet, és inspirálódhatsz másoktól
          </li>
        </ul>
      </div>
      <p className="mt-8 text-justify">
        Ezen a művészetterápiás alkalmon lehetőséged lesz saját élettörténeted egy szeletét képregényben megalkotni. Nem tanítunk rajzolni, hanem kreatív megoldásokat és biztonságos teret biztosítunk arra, hogy az alkotáson keresztül elmélyülj önmagad megismerésében.
      </p>
      <div className="mt-8 space-y-2">
        <p className="flex items-center font-semibold">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-pen-tool mr-2 h-5 w-5">
            <path d="M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z"></path>
            <path d="m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18"></path>
            <path d="m2.3 2.3 7.286 7.286"></path>
            <circle cx="11" cy="11" r="2"></circle>
          </svg>
          Mire számíthatsz a foglalkozáson?
        </p>
        <ul className="list-none space-y-2">
          <li className="flex items-center">
            <i className="bi bi-check mr-2 text-green-600"></i>
            Egyedi, képregényes formában dolgozhatod fel az életed fontos pillanatait
          </li>
          <li className="flex items-center">
            <i className="bi bi-check mr-2 text-green-600"></i>
            Megtapasztalhatod a vizuális önkifejezés felszabadító erejét
          </li>
          <li className="flex items-center">
            <i className="bi bi-check mr-2 text-green-600"></i>
            Segítünk, hogy ne a tökéletes ábrázolás, hanem az érzések kerüljenek előtérbe
          </li>
        </ul>
      </div>
      <div className="space-y-4">
        <p className="font-semibold">A csoportot vezeti:</p>
        <div className="space-y-2">
          <p>
            <strong>Bíró Beáta</strong> — művészetterápiás csoportvezető, art coach, fejlesztési és mentálhigiénés szakember, kreatív designer
            <br />
            <a href="https://beart.hu" className="text-amber-900 hover:underline">Bővebb infó rólam és a módszerekről</a>
          </p>
          <p>
            <strong>Deák Panka</strong> — tervezőgrafikus-illusztrátor, pedagógus, művészetterapeuta
            <br />
            <a href="https://www.facebook.com/pankadeakillustration" className="text-amber-900 hover:underline">Facebook oldal</a>
          </p>
        </div>
        <p className="text-sm">
          A képregényes művészetterápiás foglalkozást a <i>Lelki Forrásaink Művészetterápiás Fesztivál</i> keretében terveztük meg közös elképzelésünk alapján. <br />
          Mindketten az MMSZKE szocio- és művészetteraputa képzését végeztük el.
        </p>
      </div>
      <div className="space-y-4">
        <div className="space-y-2">
          <p className="font-semibold">
            <i className="bi bi-house-door-fill"></i> Helyszín:
          </p>
          <p>MMSZKE - Magyar Művészet- és Szocioterápiás Közösségépítő Egyesület</p>
          <p>1053 Budapest, Kossuth Lajos u. 17. III. em. 6.</p>
        </div>
        <div className="space-y-2">
          <p className="flex items-center font-semibold">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-calendar mr-2 h-5 w-5">
              <path d="M8 2v4"></path>
              <path d="M16 2v4"></path>
              <rect width="18" height="18" x="3" y="4" rx="2"></rect>
              <path d="M3 10h18"></path>
            </svg>
            Időpont:
          </p>
          <p>2025. május 3., szombat, 17:00 - 21:00</p>
        </div>
        <div className="space-y-2">
          <p className="font-semibold">Részvételi díj:</p>
          <p>12.000 Ft/fő</p>
          <p className="text-sm italic">
            A jelentkezésed akkor válik teljessé, ha a befizetési határidőre átutalod a részvételi díjat!
          </p>
        </div>
        <div className="space-y-2">
          <p className="font-semibold">Jelentkezési és befizetési határidő:</p>
          <p>április 29.</p>
        </div>
        <div className="space-y-2">
          <p className="font-semibold">Létszám:</p>
          <p>minimum 6, maximum 12 fő</p>
        </div>
      </div>
    </div>
    </>
  )
}